import { render, staticRenderFns } from "./VSearch.vue?vue&type=template&id=7c9802c0&"
import script from "./VSearch.vue?vue&type=script&lang=js&"
export * from "./VSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports